import { API_HOSTNAME, isDev } from '@/config'
import { FeatureFlag } from '@/modules/App/featureFlags'
import { useFeatureFlags } from '@/modules/App/useFeatureFlags'
import type { Channel } from 'phoenix'
import { Socket } from 'phoenix'

/**
 * Enumerates all ws channel topic formats the app supports
 */
export type AppTopic =
  | `project:${string}`
  | `workspace:${string}`
  | `spaces:${string}`
  | `case:${string}`

export type AppSocket = Socket & {
  channel: (topic: AppTopic) => Channel
}

const getEndpoint = () => {
  const { hostname, protocol, port } =
    API_HOSTNAME && !isDev ? new URL(API_HOSTNAME) : window.location
  const wsProtocol = protocol === 'https:' ? 'wss:' : 'ws:'
  const wsPort = getPort(port, protocol)
  return `${wsProtocol}//${hostname}:${wsPort}/socket`
}

const getPort = (port: string, protocol: string) => {
  if (port === '') {
    return protocol === 'https:' ? '443' : '80'
  }

  return port
}

export const createSocket = (token: string): Socket => {
  // eslint-disable-next-line internal/no-call-composable-outside-setup
  const isExperimentalBackendEnabled = useFeatureFlags(FeatureFlag.EXPERIMENTAL_BACKEND)
  return new Socket(getEndpoint(), {
    params: {
      token,
      ...(isExperimentalBackendEnabled.value ? { 'X-V7-Go-Experimental': true } : {}),
    },
    heartbeatIntervalMs: 15000,
  })
}
